import React from "react";
import InstagramFeeds from "./componant/InstagramFeeds";
import MacauBlog from "./componant/MacauBlog";
import MacauCategory from "./componant/MacauCategory";
import MacauSlider from "./componant/MacauSlider";
import MacauSubscription from "./componant/MacauSubscription";
import RingByStyle from "./componant/RingStyle";
import ShapeBy from "./componant/ShapeBy";
import TestimonialMacau from "./componant/TestimonialMacau";
import TwoBannerLayout from "./componant/TwoBannerLayout";
// import { Theme } from "../../../../Helpers/request";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// if (Theme === "macau") {
//   require(`./assets/css/macau.css`);
// }

const MacauHome = () => {
  return (
    <div className="MacauThemHome">
      <MacauSlider />
      <MacauCategory />
      <ShapeBy />
      <TwoBannerLayout />
      {/* <RingByStyle/> */}
      <TestimonialMacau />
      <MacauBlog />
      <InstagramFeeds />
      <MacauSubscription />
    </div>
  );
};

export default MacauHome;
